import SafeApiKit from '@safe-global/api-kit'
import useActiveOrDefaultChain from 'src/common/hooks/web3/useActiveOrDefaultChain'
import { useMemo } from 'react'

const useSafeApiKit = () => {
  const { id: chainId } = useActiveOrDefaultChain()

  const apiKit = useMemo(() => {
    return new SafeApiKit({
      chainId: BigInt(chainId),
    })
  }, [chainId])

  return apiKit
}

export default useSafeApiKit
